import React from 'react'

import { semanticColors, Tooltip } from '@avantstay/backoffice-core'

import { IconError } from '@avantstay/backoffice-vectors'
import { IInfoTooltip } from './_types'

function InfoTooltip(props: IInfoTooltip) {
  const hasError = Boolean(props.error)
  const backgroundColor = hasError
    ? semanticColors.failureExtraLight
    : semanticColors.warningExtraLight
  const textColor = hasError ? semanticColors.failureMedium : semanticColors.warningDark

  return (
    <Tooltip content={props.error || props.warning} arrow placement="bottom">
      <IconError
        color={props.error ? semanticColors.failureMedium : semanticColors.warningMedium}
      />
    </Tooltip>
  )
}

export default InfoTooltip
